import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'giftingBalance';

export function useGifting({
	enabled = true,
	impersonationContext,
}: {
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
} = {}) {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<Api.IGiftingBalance>(
				Api.ImpersonationBroker.composeApiUrl({ urlPath: 'gifting', impersonationContext }),
				'GET'
			);
		},
		queryKey: [BASE_QUERY_KEY, impersonationContext],
	});
}

export const invalidateGiftingBalance = () => {
	return reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
};
